<template>
    <span class="navigation-account__club-logo-content d-flex align-items-center">
        <template v-if="!isSelectedClubIndividual">
            <b-img-lazy
                v-if="clubProfileImage"
                class="navigation-account__club-image"
                :src="clubProfileImage"
                alt=""
                width="40"
            />
            <img
                v-else
                class="navigation-account__club-image"
                src="@/assets/img/general/no-club.png"
                alt=""
                width="40"
            />
        </template>

        <div class="navigation-account__club-image" v-if="isSelectedClubIndividual && me">
            <user-profile-image :user="me" size="small" img-width="40" />
        </div>

        <span class="navigation-account__club-name">{{ selectedClubName }}</span>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import UserProfileImage from '@/components/helpers/UserProfileImage.vue';
import get from 'get-object-path';

export default {
    components: {
        UserProfileImage
    },

    computed: {
        ...mapGetters({
            isSelectedClubIndividual: 'isSelectedClubIndividual',
            me: 'clubHelper/me',
            selectedClub: 'selectedClub',
            selectedClubName: 'selectedClubName'
        }),

        clubProfileImage() {
            return get(this.selectedClub, 'club.data.picture.url_128x128');
        }
    }
};
</script>
